import React from 'react';
import PCRdownloadWidget from './PCRdownlodWidget';
import { makeStyles } from '@material-ui/core/styles';
import homepageLogo from '../../assets/images/statemedicalimg.png'
import bg from '../../assets/images/bg.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    maxWidth: "100vw",
    backgroundImage: `url('${bg}')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "auto",
    '& .flexContainer': {
      margin: 0,
      padding: "63px",
      [theme.breakpoints.only('xs')]: {
        padding: "47px 24px",
      },
      '& .leftSection': {
        width: "356px",
        display: "flex",
        flexDirection: 'column',
        alignItems: "center",
        [theme.breakpoints.only('xs')]: {
          width: "100%",
        },
        '& .logo': {
          width: "100%",
          //height: "63px",
          [theme.breakpoints.only('xs')]: {
            width: "278px",
            //height: "49px",
            //textAlign: "center",
          },
        },
      },
    },
  },
}));

const PCRdownload = () => {
  const classes = useStyles();
  
  return (
    <div className={classes.root}>
      <div className={"flexContainer"}>
        <div className={"leftSection"}>
          <img src={homepageLogo} alt="" className={"logo"} />
          <PCRdownloadWidget />
        </div>
      </div>
    </div>
  );
};

export default PCRdownload;